import { gql } from "@apollo/client";

export const UPDATE_USER_EMAIL_PREFERENCE = gql`
    mutation UpdateUserEmailPreference($input: EmailPreferenceInput!) {
        updateUserEmailPreference(input: $input) {
            message
        }
    }
`;

export const GET_UNSUBSCRIBE_REASONS = gql`
    query GetUnsubscribeReasons {
        unsubscribe_reasons {
            ur_id
            ur_reason_text
            ur_created_at
            ur_updated_at
            ur_deleted_at
        }
    }
`

export const GET_USER_EMAIL_PREFERENCES = gql`
query GetUserEmailPreferences($userId: uuid!) {
    user(where: {u_id: {_eq: $userId}}) {
        u_weekly_email_enabled
        u_season_email_enabled
    }
}
`
